export const buildReissueXmlCdoPayload = ({
	loanGuid,
	borrowerPairId,
	creditReportIdentifier,
	reportOn,
	transactionId,
	providerId,
	statusResponse,
}) => ({
	loan_guid: loanGuid,
	borrower_id: borrowerPairId,
	credit_report_number: creditReportIdentifier,
	report_on: reportOn,
	transaction_id: transactionId,
	provider_id: providerId,
	status_response: statusResponse,
});
